// extracted by mini-css-extract-plugin
module.exports = {"price":"caravanPrice_price__ZJovS"};